// Single source of truth for the public demo experience.
// Read both server- and client-side; inlined at build time by Next.js so
// the entire demo surface (page, UI, credentials) is tree-shaken out of
// buyer client bundles when the flag is not set to "on".
export const DEMO_MODE_ENABLED = process.env.NEXT_PUBLIC_DEMO_MODE === 'on';

export const DEMO_OWNER_EMAIL = 'demo@restroagent.com';
export const DEMO_OWNER_PASSWORD = 'demo123456';
export const DEMO_ADMIN_EMAIL = 'admin@restroagent.com';
export const DEMO_ADMIN_PASSWORD = 'admin123456';

// Support comma-separated emails from environment variables, fallback to defaults
const customDemoEmails = process.env.NEXT_PUBLIC_DEMO_EMAILS
  ? process.env.NEXT_PUBLIC_DEMO_EMAILS.split(',').map(email => email.trim().toLowerCase())
  : [];

export const DEMO_EMAILS = new Set<string>([
  DEMO_OWNER_EMAIL.toLowerCase(),
  DEMO_ADMIN_EMAIL.toLowerCase(),
  ...customDemoEmails
]);


